import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';

export interface VendorInvoiceScanProposal {
  success: boolean;
  proposed?: boolean;
  requiresConfirmation?: boolean;
  message?: string;
  token?: string;
  extract?: {
    method?: string;
    confidence?: string;
    layoutWarning?: string;
    originalName?: string;
  };
  header?: {
    vendorName?: string;
    vendorHints?: string[];
    templateId?: string;
    templateLabel?: string;
    invoiceNumber?: string;
    invoiceDate?: string;
    shipping?: number;
    tax?: number;
    tariff?: number;
    subtotal?: number;
    total?: number;
    confidence?: string;
  };
  lines?: any[];
  match?: {
    matchedLines?: any[];
    exceptions?: Array<{ type: string; message: string; orderId?: string }>;
    unreadableFields?: string[];
  };
  duplicateInvoice?: boolean;
  layoutWarning?: string;
  previewPages?: string[];
  invoiceAttachment?: {
    fileName?: string;
    originalName?: string;
    contentType?: string;
    uploadedAt?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class VendorInvoiceScanService {
  private baseUrl = environment.base_url + '/vendorInvoice';

  constructor(private http: HttpClient, private auth: AuthService) {}

  scanInvoice(
    file: File,
    vendorId: string,
    awaitingOrders: any[],
    vendorName?: string
  ): Observable<VendorInvoiceScanProposal> {
    const form = new FormData();
    form.append('invoice', file, file.name);
    form.append('vendorId', vendorId || '');
    form.append('vendorName', vendorName || '');
    form.append('store', String(this.auth.getStore() || ''));
    form.append('awaitingOrders', JSON.stringify(awaitingOrders || []));
    return this.http.post<VendorInvoiceScanProposal>(`${this.baseUrl}/scan`, form).pipe(
      take(1),
      tap((res) => this.auth.updateToken(res))
    );
  }
}
